import { render, staticRenderFns } from "./FpMessage.vue?vue&type=template&id=01ac23f9&scoped=true"
import script from "./FpMessage.vue?vue&type=script&lang=ts"
export * from "./FpMessage.vue?vue&type=script&lang=ts"
import style0 from "./FpMessage.vue?vue&type=style&index=0&id=01ac23f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_babel-core@6.26.3_css-loader@6.11.0_webpack@5.111_qiwspig4cowntqqutyssg3tktu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ac23f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/.pnpm/vuetify-loader@1.7.3_vue-template-compiler@2.7.16_vuetify@2.7.2_vue@2.7.16__webpack@5.111.1_l_l56bdxpzvhkruchihen76mu6ae/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
